import { GetListRequestParams, GetListResponse, instance } from "libs/api";

import { ApiRoutesDrivers } from "../../constants";
import { Driver } from "../../drivers.types";

export const requestGetDrivers = async (
  params: GetListRequestParams
): Promise<GetListResponse<Driver>> => {
  return await instance.get(ApiRoutesDrivers.Drivers, { params });
};
